import React, {useState} from 'react';
import {Box, Zoom, Typography, Modal, Button, Paper} from '@mui/material';
import ClarificationSlider from './ClarificationSlider';
import { Article, CancelOutlined } from '@mui/icons-material';

export default function AnswerReaction(props) {

    const [modalOpen, setModalOpen] = useState(false);
    const handleModalOpen = () => setModalOpen(true);
    const handleModalClose = () => setModalOpen(false);

    const okButtonStyle = {
        display: "block",
        margin: "1rem 0 0 0"
    }

    const buttonWrapper = {
        display: "inline-flex",
        margin: "auto"
    }
    
    const itemStyle = {
        display: "block",
        margin: "auto",
        width: "10rem",
        height: "auto"
    }

    const goOn = () => {
        props.setAnswered(false);
        props.handleAnswer();
    }

    const showPrompt = () => {
        if (props.correct === "correct") {
            return <CorrectPrompt clarification={props.clarification} handleModalOpen={handleModalOpen}
                buttonWrapper={buttonWrapper} goOn={goOn} okButtonStyle={okButtonStyle}
                isLastQuestion={props.isLastQuestion}
            />
        } else if (props.correct === "partial_correct") {
            return <PartialCorrectPrompt itemStyle={itemStyle} buttonWrapper={buttonWrapper} setAnswered={props.setAnswered} 
                okButtonStyle={okButtonStyle}
            />
        } else {
            return <IncorrectPrompt itemStyle={itemStyle} buttonWrapper={buttonWrapper} setAnswered={props.setAnswered} 
                okButtonStyle={okButtonStyle}
            />
        }
    }

    return(
        <>
            <Box>
                {showPrompt()}
            </Box>
            
            <Modal
                open={modalOpen}
                onClose={handleModalClose}
            >
                <Paper
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap:"wrap",
                        justifyContent: "center",
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        maxWidth: 400,
                        minWidth: 300,
                        p: {
                            xs: 2,
                            md: 4,
                        },
                        overflowY: "auto",
                        maxHeight: "60vh"
                    }}
                >
                    <Typography align="start"
                        sx={{flexBasis: "100%"}}
                    >
                        {props.clarification}
                    </Typography>
                    <Button onClick={handleModalClose} variant="contained"
                        sx={{mt: 2, width: "100%"}}
                    >Zurück</Button>
                </Paper>
            </Modal>
        </>
    )
}

function CorrectPrompt(props) {
    return <Box sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
        <Zoom in style={{ transitionDelay: 500 }} >
            <Typography variant="h3">Richtig!</Typography>
        </Zoom>
        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <ClarificationSlider text={props.clarification}/>
            <Button onClick={props.handleModalOpen} sx={{width: "fit-content"}}
                endIcon={<Article/>}
            >
                Alles lesen
            </Button>
        </Box>
        <Box style={props.buttonWrapper}>
            <Zoom in style={{ transitionDelay: 1500 }} >
                <Button onClick={props.goOn} variant="contained" color="secondary" style={props.okButtonStyle}>
                    {props.isLastQuestion ? "Abschließen" : "Nächste Frage"}
                </Button>
            </Zoom>
        </Box>
    </Box>
}

function PartialCorrectPrompt(props) {
    return <Box sx={{display: "flex", flexDirection: "column"}}>
        <Zoom in style={{ transitionDelay: 500 }} >
            <Box sx={{display: "flex", alignItems: "center", flexDirection:"column"}}>
                <CancelOutlined color="secondary" style={props.itemStyle}  />
                <Typography>Da fehlt noch etwas...</Typography>
                <Typography>Probier es weiter!</Typography>
            </Box>
        </Zoom>
        <Zoom in style={{ transitionDelay: 1000 }} >
            <Box style={props.buttonWrapper}>
                <Button onClick={() => props.setAnswered(false)} variant="contained" color="primary" style={props.okButtonStyle}>
                    Nochmal
                </Button>
            </Box>
        </Zoom>
    </Box>
}

function IncorrectPrompt(props) {
    return <Box sx={{display: "flex", flexDirection: "column"}}>
        <Zoom in style={{ transitionDelay: 500 }} >
            <Box sx={{display: "flex", alignItems: "center", flexDirection:"column"}}>
                <CancelOutlined color="error" style={props.itemStyle}  />
                <Typography>Leider falsch, probier's nochmal</Typography>
            </Box>
        </Zoom>
        <Zoom in style={{ transitionDelay: 1000 }} >
            <Box style={props.buttonWrapper}>
                <Button onClick={() => props.setAnswered(false)} variant="contained" color="primary" style={props.okButtonStyle}>
                    Nochmal
                </Button>
            </Box>
        </Zoom>
    </Box>
}